<template>
  <div>
    <mobialis-form-with-validation
      @onValidate="continueForm"
      v-av-analytics-form-submit="{ elementText: $t('message.common.continue') }"
    >
      <div :class="{ 'row justify-content-between': showBlocks }">
        <div :class="{ 'col-sm-7': showBlocks }">
          <HelpUsVerify v-if="isAVRDesktop || isAVREmbed"></HelpUsVerify>

          <mobialis-text-input-with-validation
            :rules="birthDateValidationRule"
            :label="$t('message.credit.birthday')"
            v-model="birthdate"
            :helper="$t('message.credit.birthdayHelper')"
            vid="birthdate"
            mask-type="date"
            inputmode="numeric"
            :raw="false"
            data-cy="birthdate"
          ></mobialis-text-input-with-validation>
          <mobialis-text-input-with-validation
            rules="required"
            :label="$t('message.credit.streetAddress')"
            v-model="streetAddress"
            vid="streetaddress"
            data-cy="streetAddress"
          ></mobialis-text-input-with-validation>
          <mobialis-text-input-with-validation
            :label="$t('message.credit.unit#')"
            v-model="unitNumber"
            vid="unitNumber"
            data-cy="unitNumber"
          ></mobialis-text-input-with-validation>
          <mobialis-text-input-with-validation
            rules="required"
            :label="$t('message.common.city')"
            v-model="city"
            vid="city"
            data-cy="city"
          ></mobialis-text-input-with-validation>
          <mobialis-selection-input-with-validation
            rules="required"
            :label="$t('message.common.province')"
            v-model="province"
            vid="province"
            :placeHolder="$t('message.common.chooseProvince')"
            :options="provinces"
            data-cy="province"
          ></mobialis-selection-input-with-validation>
          <mobialis-text-input-with-validation
            v-if="!getFeatureList.creditPostalCodeFirstPage"
            rules="required|length:6"
            :label="$t('message.common.postalCode')"
            v-model="postalCode"
            vid="postalCode"
            mask-type="postalCode"
            data-cy="postalCode"
          ></mobialis-text-input-with-validation>
        </div>
        <div v-if="showBlocks" class="col-sm-4 d-none d-sm-block">
          <DisclaimerCard
            class="card border-0 shadow mb-4"
            :iconSrc="require('@/assets/eye.svg')"
            :title="$t('message.credit.creditform2CardTitle')"
            :text="creditForm2CardText"
            :text-left-space="false"
          ></DisclaimerCard>
          <MobialisCard class="mb-4">
            <img class="license mb-4" :src="require('@/assets/license.svg')" alt="License" />
            <p>
              {{ $t('message.credit.reviewformCardText') }}
            </p>
          </MobialisCard>
        </div>
      </div>
      <mobialis-button data-cy="submitForm2" type="submit" class="mt-4 mb-1">{{
        $t('message.common.continue')
      }}</mobialis-button>
      <p class="d-flex justify-content-center small my-0">{{ $t('message.credit.disclaimer.noAffectScore') }}</p>
    </mobialis-form-with-validation>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HelpUsVerify from '@/components/credit/hero/HelpUsVerify.vue';
import DisclaimerCard from '@/components/DisclaimerCard.vue';
import log from '@/services/log';
import { provinceMixin, formMixin } from '@/mixins';

export default {
  name: 'CreditForm2',
  mixins: [provinceMixin, formMixin],
  data() {
    return {
      birthdate: '',
      streetAddress: '',
      unitNumber: '',
      city: '',
      province: '',
      postalCode: '',
    };
  },
  components: {
    DisclaimerCard,
    HelpUsVerify,
  },
  computed: {
    ...mapGetters('business', ['getBankStrips', 'getFeatureList', 'displayEquifaxBranding']),

    creditForm2CardText() {
      if (this.displayEquifaxBranding) {
        return this.$t('message.credit.creditform2EquifaxCardText');
      }
      return this.$t('message.credit.creditform2CardText');
    },
  },
  mounted() {
    this.birthdate = this.$store.state.user.birthdate;
    this.streetAddress = this.$store.state.user.streetAddress;
    this.unitNumber = this.$store.state.user.unit;
    this.city = this.$store.state.user.city;
    this.province = this.$store.state.user.province;
    this.postalCode = this.$store.state.user.postalCode;
  },
  methods: {
    async continueForm(isValid) {
      if (!isValid) {
        return;
      }
      try {
        this.$store.commit('user/SET_BIRTHDATE', this.birthdate);
        this.$store.commit('user/SET_STREET_ADDRESS', this.streetAddress);
        this.$store.commit('user/SET_UNIT', this.unitNumber);
        this.$store.commit('user/SET_CITY', this.city);
        this.$store.commit('user/SET_PROVINCE_CODE', this.getProvinceCode(this.province));
        this.$store.commit('user/SET_PROVINCE', this.province);
        this.$store.commit('user/SET_POSTAL_CODE', this.postalCode);

        this.$router.push('form-review');
      } catch (err) {
        this.$store.commit('SET_LOADING', false);
        log('Error in Creditform 2', err);
        this.$router.push({ name: `credit-in-error-${this.baseRoute}` });
      } finally {
        try {
          await this.$store.dispatch('lead/updateLead');
        } catch (err) {
          this.$store.commit('SET_LOADING', false);
          log('Error in Creditform 2 - Update Lead', err);
          this.$router.push({ name: `credit-in-error-${this.baseRoute}` });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.license {
  max-width: 100%;
}
</style>
